import pickBy from 'lodash/pickBy';

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
export default function removeUndefined(obj: any) {
  return pickBy(obj, value => value !== undefined);
}
